import {getFeaturesFromParent} from "../handler/ParentDataHandler";
import {chainWalk} from "./Util";

export const FEATURES = {
    IS_SSD3_ENABLED: "isSSD3Enabled",
    IS_MHE_VALIDATION_ENABLED: "isMHEValidationEnabled",
    IS_SSD_2_X_ENABLED: "isSSD2XEnabled",
    IS_RFID_BAGS_ENABLED: "isRFIDBagsEnabled",
    IS_DMW_PERMISSIONS_ENABLED: "isDMWPermissionsEnabled"
}

/**
 * Use this class whenever there is a requirement whenever a feature context variable
 * is required to be used for both components and other objects.
 */
export class FeatureUtility {
    static featureStatus = {};

    static getFeatureStatus(featureName) {
        return chainWalk(() => FeatureUtility.featureStatus[featureName], false);
    }

    static setAllFeatureStatuses() {
        return getFeaturesFromParent(Object.values(FEATURES)).then(featureStatusResponse => {
            Object.values(FEATURES).forEach((featureName) => {
                FeatureUtility.featureStatus[featureName] =
                    chainWalk(() => featureStatusResponse.data[featureName], false)
            })
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/util/FeatureUtility.js